module.exports = __webpack_public_path__ + "img/store.bcf19a02.svg";